import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "more-indicator-verbiage more-info-icon" }
const _hoisted_2 = { class: "less-indicator-verbiage more-info-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VMarkdownView = _resolveComponent("VMarkdownView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      (_ctx.showDescription && !_ctx.inlineDescription) ||
      (_ctx.showDescription && _ctx.inlineDescription && _ctx.extraDescription.length === 0)
    )
      ? _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.descriptionCss || 'ml-5'),
            "data-testid": "block-description"
          }, _toDisplayString(_ctx.shortDescription), 3)
        ], true, 0)
      : _createCommentVNode("", true),
    (_ctx.showDescription && _ctx.showExtended && _ctx.extraDescription)
      ? (_openBlock(), _createElementBlock("details", {
          key: 1,
          class: _normalizeClass(["more-info", _ctx.extendedCss])
        }, [
          _createElementVNode("summary", null, [
            (_ctx.showDescription && _ctx.inlineDescription)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.descriptionCss),
                  "data-testid": "inline-description"
                }, _toDisplayString(_ctx.shortDescription), 3))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_1, [
              _createTextVNode(_toDisplayString(_ctx.$t("more")) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-chevron-right" }, null, -1))
            ]),
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$t("less")) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "glyphicon glyphicon-chevron-down" }, null, -1))
            ])
          ]),
          (_ctx.allowHtml)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["more-info-content", _ctx.markdownContainerCss]),
                "data-testid": "markdown-container"
              }, [
                _createVNode(_component_VMarkdownView, {
                  mode: "",
                  content: _ctx.extraDescription
                }, null, 8, ["content"])
              ], 2))
            : _renderSlot(_ctx.$slots, "extraDescriptionText", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.extraDescription), 1)
              ], true, 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}